import React from 'react';

export const IconCameraErro = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        width='90px'
        height='63px'
        viewBox='0 0 90 63'
        enableBackground='new 0 0 90 63'
        xmlSpace='preserve'
    >
        <image
            id='image0'
            width='90'
            height='63'
            x='0'
            y='0'
            href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAA/CAQAAADKmBdgAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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'
        />
    </svg>
);
